import React, { ChangeEvent, useEffect, useState } from 'react';
import Image from 'next/image';
import { useRouter } from 'next/router';
import Button from 'components/Button';
import AskModal from 'components/Modals/AskModal';
import { CategoriesGrades } from 'views/QuestionsWithCategories/QuestionsWithCategories.data';
import removeQueryParam from 'utils/removeQueryParam';
import styles from './CategoriesPanel.module.css';

type CategoriesPanelProps = {
  subject: {
    name: string;
    imageName: string;
    link: string;
  };
};

const CategoriesPanel = ({ subject }: CategoriesPanelProps) => {
  const [showAskModal, setShowAskModal] = useState<boolean>(false);
  const [gradeValue, setGradeValue] = useState<string>('');

  const router = useRouter();
  const changeGradeHandler = async (e: ChangeEvent<HTMLSelectElement>) => {
    e.preventDefault();
    setGradeValue(e.target.value);

    if (!e.target.value) {
      const url = new URL(window.location.origin + router.asPath);
      const canonicalUrl = url.pathname;
      return await router.push(canonicalUrl, undefined);
    }

    await router.push(
      {
        query: {
          ...removeQueryParam(router, 'page'),
          klass: e.target.value,
        },
      },
      undefined,
    );
  };

  useEffect(() => {
    setGradeValue((router.query.klass as string) || '');
  }, [router]);

  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <div className={styles.panel}>
          <div className={styles.navigation}>
            <div className={styles.icon}>
              <Image
                src={`https://static.uchi.ru/files/otvety/subjects/${subject.imageName}.svg`}
                width={72}
                height={72}
                alt=""
              />
            </div>
            <h1 className={styles.title}>{subject.name.replace(/[-]/g, '')}</h1>
            <select
              onChange={(e) => changeGradeHandler(e)}
              className={styles.select}
              value={gradeValue}
            >
              {CategoriesGrades.map((i) => (
                <option key={i.value} value={i.value}>
                  {i.label}
                </option>
              ))}
            </select>
          </div>
          <Button
            text="Задать вопрос"
            onClick={() => setShowAskModal(true)}
            className={styles.new_question_btn}
          />
        </div>
      </div>
      {showAskModal && (
        <AskModal onClose={() => setShowAskModal(false)} tryCreateNew="question" />
      )}
    </div>
  );
};

export default CategoriesPanel;
